import React, { useState } from 'react';

const ImprintContent: React.FC = () => {
  // State to manage the current language (default: English)
  const [language, setLanguage] = useState<'en' | 'de'>('en');

  // Language toggle handler
  const toggleLanguage = (lang: 'en' | 'de') => {
    setLanguage(lang);
  };

  return (
    <div className="space-y-8">
      {/* Language Toggle Buttons */}
      <div className="flex justify-end space-x-4 mb-4">
        <button
          onClick={() => toggleLanguage('en')}
          className={`px-4 py-2 rounded ${language === 'en' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
        >
          English
        </button>
        <button
          onClick={() => toggleLanguage('de')}
          className={`px-4 py-2 rounded ${language === 'de' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
        >
          Deutsch
        </button>
      </div>

      {/* Conditional Rendering for English Content */}
      {language === 'en' && (
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Imprint</h1>
          <section className="space-y-2">
            <p className="font-medium">Simon Stürzenhofecker</p>
            <p>Digital Marketer (Sole Trader)</p>
            <p>Birkenstrasse 1</p>
            <p>91249 Weigendorf</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Contact</h2>
            <p>Phone: +49 (0) 176 24938417</p>
            <p>Email: info@simons-marketing-solutions.com</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Tax ID</h2>
            <p>VAT identification number according to Section 27a of the Sales Tax Law: 201/279/10767</p> {/*201/279/10767*/}
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">EU dispute settlement</h2>
            <p>The European Commission provides a platform for online dispute resolution (ODR):
                https://ec.europa.eu/consumers/odr/.
            </p>
            <p>
              You can find our email address above in the imprint.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Consumer dispute resolution/universal arbitration board</h2>
            <p>We are not willing or obliged to participate in dispute resolution proceedings before a
              Consumer arbitration board.

              Central contact point under the Digital Services Act - DSA
              (Regulation (EU) 2022/265)
            </p>
            <p>
              Our central contact point for users and authorities according to Art. 11, 12 DSA can be reached as follows:
            </p>
            <p>
              Email: info@simons-marketing-solutions.com
            </p>
            <p>
              Phone: +49 (0) 176 24938417
            </p>
            <p>
              Picturesource: https://images.unsplash.com/photo-1460925895917-afdab827c52f (Images from Unsplash may be used commercially under their license)
            </p>  
            
          </section>
          
        </div>
      )}

      {/* Conditional Rendering for German Content */}
      {language === 'de' && (
        <div>
         <h1 className="text-3xl font-bold text-gray-900">Impressum</h1>
          <section className="space-y-2">
            <p className="font-medium">Simon Stürzenhofecker</p>
            <p>Digitaler Marketer (Einzelunternehmer)</p>
            <p>Birkenstrasse 1</p>
            <p>91249 Weigendorf</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Kontakt</h2>
            <p>Telefon: +49 (0) 176 24938417</p>
            <p>E-Mail: info@simons-marketing-solutions.com</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Umsatzsteuer-ID</h2>
            <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
              201/279/10767
            </p>
          </section> {/*201/279/10767*/}

          <section>
            <h2 className="text-xl font-semibold mb-3">EU-Streitschlichtung</h2>
            <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
              https://ec.europa.eu/consumers/odr/.
            </p>
            <p>
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Verbraucherstreitbeilegung/Universalschlichtungsstelle</h2>
            <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
            <p>
              Zentrale Kontaktstelle nach dem Digital Services Act - DSA
              (Verordnung (EU) 2022/265)
            </p>
            <p>
              Unsere zentrale Kontaktstelle für Nutzer und Behörden nach Art. 11, 12 DSA erreichen Sie wie folgt:
            </p>
            <p>
              E-Mail: info@simons-marketing-solutions.com
            </p>
            <p>
              Telefon: +49 (0) 176 24938417
            </p>
            <p>
              Bildquelle: https://images.unsplash.com/photo-1460925895917-afdab827c52f (Bilder von Unsplash dürfen unter deren Lizenz     kommerziell verwendet werden)
            </p>
            
          </section>
        </div>
      )}
    </div>
  );
};

export default ImprintContent;